import { skeemaApi } from '../skeema'
import {
  USER_RESET_ENDPOINT_PATH,
  USER_ADMIN_LIST_ENDPOINT_PATH,
  USER_ADMIN_UPDATE_PREMIUM_STATUS_ENDPOINT_PATH,
  UserResetEndpointType,
  UserAdminListEndpointType,
  UserAdminUpdatePremiumStatusEndpointType,
} from '../../../models/endpoints.types'

export const usersApi = skeemaApi.injectEndpoints({
  endpoints: (builder) => ({
    resetUserData: builder.mutation<UserResetEndpointType['POST']['response'], { id: number }>({
      query: ({ id }) => ({
        url: `${USER_RESET_ENDPOINT_PATH(String(id))}`,
        method: 'POST',
      }),
    }),
    getAdminUsers: builder.query<
      UserAdminListEndpointType['GET']['response'],
      UserAdminListEndpointType['GET']['queryParams']
    >({
      query: ({ search = '', tier = '', page = 1, page_size = 200 }) => ({
        url: USER_ADMIN_LIST_ENDPOINT_PATH,
        method: 'GET',
        params: { search, tier, page, page_size },
      }),
    }),
    updateUserPremiumStatus: builder.mutation<
      UserAdminUpdatePremiumStatusEndpointType['POST']['response'],
      UserAdminUpdatePremiumStatusEndpointType['POST']['body']
    >({
      query: ({ email, is_premium }) => ({
        url: USER_ADMIN_UPDATE_PREMIUM_STATUS_ENDPOINT_PATH,
        method: 'POST',
        body: { email, is_premium },
      }),
    }),
  }),
})

export const {
  useResetUserDataMutation,
  useGetAdminUsersQuery,
  useUpdateUserPremiumStatusMutation,
} = usersApi
